module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-07-7b370012f61c1f6ec82d6e1761f79883.png";